import { Form, Input, Modal, Switch, Row, Col } from "antd";
import { useMutation } from "react-query";
import { createRole, editRole } from "../../../api/roles";
import { extractCheckedIds } from "../Permissions";
import { useEffect, useState } from "react";
import Title from "../../UI/Title/Title";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { message } from "antd";
type PropsType = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refetchRoles: () => {};
  selectedRole: any;
  setSelectedRole: any;
};

const AddRoleModal = ({
  isOpen,
  setIsOpen,
  refetchRoles,
  selectedRole,
  setSelectedRole,
}: PropsType) => {
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [t] = useTranslation("common");

  const [isActive, setIsActive] = useState(selectedRole?.isActive);
  const [isSystem, setIsSystem] = useState(selectedRole?.isSystem);
  const navigate = useNavigate();

  const { mutateAsync: addEditRoleMutation } = useMutation(
    selectedRole ? "editRole" : "addRole",
    selectedRole
      ? (details: any) => editRole(details)
      : (details: any) => createRole(details)
  );
  const [, setError] = useState();
  const [open, setOpen] = useState(false);
  const handleAddRole = () => {
    addEditRoleMutation(
      selectedRole
        ? {
            id: selectedRole.id,
            name: form.getFieldValue("name"),
            permissionIds: extractCheckedIds(selectedRole?.permissions),
            description: form.getFieldValue("description"),
            isSystem: form.getFieldValue("isSystem"),
            isActive: form.getFieldValue("isActive"),
          }
        : {
            name: form.getFieldValue("name"),
            permissionIds: [],
            description: form.getFieldValue("description"),
            isSystem: form.getFieldValue("isSystem"),
            isActive: form.getFieldValue("isActive"),
          }
    )
      .then((res) => {
        refetchRoles();
        setIsOpen(false);
        form.resetFields();
        !selectedRole &&
          navigate("/permissions", {
            state: {
              roleId: res.data.id,
            },
          });
        setOpen(false);
      })
      .catch((err) => {
        setError(err.response.data.errors[0].msg);
        message.error(err.response.data.errors[0].msg);
      });
  };

  useEffect(() => {
    setIsActive(selectedRole?.isActive);
    form.setFieldsValue({
      name: selectedRole?.name,
      description: selectedRole?.description,
      isActive: selectedRole ? isActive : true,
      isSystem: selectedRole ? isSystem : true,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRole]);

  return (
    <>
      <Modal
        centered
        destroyOnClose
        open={isOpen}
        maskClosable={false}
        closable={false}
        okText={selectedRole ? `${t("save")}` : `${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
        onCancel={() => {
          setIsOpen(false);
          form.resetFields();
          setSelectedRole();
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !form.getFieldValue("name"), // Disable the button if name or description is empty
        }}
      >
        <Row>
          <Col span={20} style={{ marginBottom: "20px" }}>
            <Title
              title={selectedRole ? `${t("edit-role")}` : `${t("add-role")}`}
            />
          </Col>
          <Col span={14}>
            <Form
              form={form}
              layout="vertical"
              id="roleform"
              onFinish={() => {
                handleAddRole();
              }}
            >
              <Form.Item
                name="name"
                label={t("role-name")}
                rules={[
                  {
                    required: true,
                    message: "role name is required",
                  },
                ]}
                shouldUpdate
              >
                <Input
                  maxLength={50}
                  placeholder={`${t("enter-text")}`}
                  autoComplete="off"
                />
              </Form.Item>
              <Form.Item name="description" label={t("description")}>
                <TextArea
                  autoComplete="off"
                  autoSize={{ minRows: 4, maxRows: 4 }}
                  placeholder={`${t("enter-text")}`}
                  className="scrollable-textarea"
                />
              </Form.Item>

              <Form.Item
                name="isActive"
                label={`${t("status")}`}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Switch
                  checked={isActive}
                  defaultChecked={selectedRole ? isActive : true}
                  checkedChildren={t("active")}
                  unCheckedChildren={t("inactive")}
                  onChange={(e) => {
                    setIsActive(e);
                  }}
                  disabled={selectedRole?false:true}
                />
              </Form.Item>

              <Form.Item
                name="isSystem"
                label={`${t("admin")}`}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Switch
                  checked={isSystem}
                  defaultChecked={selectedRole ? isSystem : true}
                  checkedChildren={t("true")}
                  unCheckedChildren={t("false")}
                  onChange={(e) => {
                    setIsSystem(e);
                  }}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Modal>
      <AddEditModal
        form="roleform"
        open={open}
        id={selectedRole}
        setOpen={setOpen}
        name={<span>{selectedRole?.name}</span>}
        title={`${t("role")}`}
      />
    </>
  );
};

export default AddRoleModal;
